import { render, staticRenderFns } from "./QuestionReports.vue?vue&type=template&id=2825a857&scoped=true&"
import script from "./QuestionReports.vue?vue&type=script&lang=ts&"
export * from "./QuestionReports.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionReports.vue?vue&type=style&index=0&id=2825a857&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825a857",
  null
  
)

export default component.exports